// ── 기간 필터 바 컴포넌트 ──────────────────────────────────────────────────────
import React from 'react';
import { filterWrap, inputStyle, btnSecondary } from './styles';

/**
 * 기간(시작일~종료일) 입력 + 조회 버튼
 * Props:
 *   filterStart, setFilterStart - 시작일 상태
 *   filterEnd,   setFilterEnd   - 종료일 상태
 *   onSearch                    - 조회 버튼 클릭 핸들러
 *   --- 아래는 선택적 (카드승인 탭에서만 사용) ---
 *   approvalSearchNode          - 승인번호 검색 노드 (ReactNode) — 있으면 조회 버튼 뒤에 구분선과 함께 표시
 */
export function FilterBar({
  filterStart, setFilterStart,
  filterEnd,   setFilterEnd,
  onSearch,
  approvalSearchNode,
}) {
  return (
    <div style={filterWrap}>
      {/* 기간 필터 */}
      <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>기간</span>
      <input type="date" style={inputStyle} value={filterStart} onChange={(e) => setFilterStart(e.target.value)} />
      <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>~</span>
      <input type="date" style={inputStyle} value={filterEnd} onChange={(e) => setFilterEnd(e.target.value)} />
      {/* 조회 = 보조 버튼(흰 외곽선) — 검정 CTA는 각 탭의 등록/업로드 하나만 */}
      <button style={{ ...btnSecondary, padding: '6px 12px' }} onClick={onSearch}>조회</button>

      {/* 승인번호 검색 — 있을 때만 구분선 + 검색창 표시 */}
      {approvalSearchNode && (
        <>
          <span style={{ width: 1, height: 20, background: 'var(--border)', margin: '0 4px' }} />
          {approvalSearchNode}
        </>
      )}
    </div>
  );
}
